import { render } from "./IconOpportunity.vue?vue&type=template&id=00209465&ts=true"
import script from "./IconOpportunity.vue?vue&type=script&lang=ts"
export * from "./IconOpportunity.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__